module.exports = __webpack_public_path__ + "static/media/recordr.6f41c42f.png";